import axios from 'axios';
import _ from 'lodash';
import * as types from '../mutation-types'
import {reportAxiosError} from "../../helpers";


const state = {

    connections: [],

};

const getters = {

    all: state => state.connections,
    enabled: state => _.filter(state.connections, { 'enabled': true }),
    enabledWithoutConfiguration: state => _.filter(state.connections, { 'enabled': true, 'configured': false }),

};

const actions = {

    load ({ commit, state }, payload) {
        if((typeof payload.force === 'undefined' || !payload.force) && state.connections.length > 0) {
            return;
        }


        let path = '/app/data/connections';
        if(typeof payload.isRegistration !== 'undefined' && payload.isRegistration) {
            path = '/sign-up/connections';
        }

        return axios.get(path)
            .then((response) => {
                if(response.status === 200) {
                    if(response.data.connections && response.data.connections.length > 0) {
                        _.each(response.data.connections, (connection, index) => {
                            response.data.connections[index].rawKey = connection.key;
                            response.data.connections[index].key = _.camelCase(connection.key);
                        });
                    }

                    commit(types.SET_CONNECTIONS, response.data.connections);
                } else {
                    this.dispatch('messages/handleXHRFailureMessages', {response: response});
                }
            })
            .catch((error) => {
                reportAxiosError(error);
                this.dispatch('messages/handleXHRFailureMessages', error);
            });
    },

    clear ({ commit, state }) {
        if(state.connections.length <= 0) {
            return;
        }

        commit(types.SET_CONNECTIONS, []);
    },

};

const mutations = {

    [types.SET_CONNECTIONS] (state, items) {
        state.connections = items
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}